import { render } from "./ModalAsociaMenu.vue?vue&type=template&id=7f4b3ce0"
import script from "./ModalAsociaMenu.vue?vue&type=script&lang=js"
export * from "./ModalAsociaMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__